export default "__VITE_ASSET__CjnhCgGf__"